@if (isLoading) {
  <app-chart-loading/>
} @else {
    <div [id]="config.chartId" class="line-canvas"></div>
}

